import { instance } from 'api/api';
import { APIResponse } from 'tools/types';
import { RawIssuesContext } from 'api/element-issues';

export const domainIssuesAPI = {
    async getContext(domainId: number): Promise<RawIssuesContext> {
        const response = await instance.get<APIResponse<RawIssuesContext>>(`data/admin/domain/${domainId}/issues`);
        return response.data.data;
    },

    // TODO(MI-29762): backend endpoints appear with the domain profiling engine; until then the
    // issues context is always empty, so these are never invoked.
    async answerQuestion(domainId: number, questionId: string, answer: string): Promise<void> {
        await instance.post(`data/admin/domain/${domainId}/clarifying-question/${questionId}/answer`, { answer });
    },

    async skipQuestion(domainId: number, questionId: string): Promise<void> {
        await instance.post(`data/admin/domain/${domainId}/clarifying-question/${questionId}/skip`);
    },

    async undoQuestion(domainId: number, questionId: string): Promise<void> {
        await instance.post(`data/admin/domain/${domainId}/clarifying-question/${questionId}/undo`);
    },
};
